var React = require('react');

function Pw (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M-70.3 0h640v480h-640z"}))),React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt","clipPath":"url(#a)","transform":"translate(70.3)","key":1},[React.createElement("path",{"fill":"#4aadd6","d":"M-173.4 0h846.3v480h-846.3z","key":0}),React.createElement("path",{"fill":"#ffde00","d":"M335.6 232.1a135.9 130.1 0 1 1-271.7 0 135.9 130.1 0 1 1 271.7 0z","key":1})])]);
}

Pw.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Pw;

Pw.default = Pw;
